import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Text,
  VStack,
} from '@chakra-ui/react';
import { FC } from 'react';
import { useAppContext } from '@frx/frx-react-context';
import { NotRegistered as NotRegisteredImage } from '../../assets';
import { useIsMobile } from '../../hooks';
import { getDataTracking } from '../../utils';

const Patient = () => (
  <VStack minW={['100%', '300px']}>
    <Image
      src={NotRegisteredImage}
      alt="Kamyrn, a St. Jude patient, wearing a red “We Won’t Stop” St. Jude shirt cheering while looking to the upper right."
      maxW="160px"
      data-testid="KamyrnImage"
    />
    <Box>
      <Text fontStyle="italic" align="center" fontSize="xs" w="full">
        St. Jude Kamyrn, diagnosed with B-cell
        <br />
        acute lymphoblastic leukemia (B-cell ALL).
      </Text>
    </Box>
  </VStack>
);

const RegisterForEvent = (props: { eventPage: string }) => {
  const { eventPage } = props;
  const isMobile = useIsMobile();

  return (
    <VStack minW={['100%', 'auto']} spacing={4} align="left" maxW="500px">
      <Heading fontWeight="normal" mt={8} size="xl" aria-label="not registered">
        You're not registered for this event.
      </Heading>

      <Text>
        You will need to register on the event page in order to access your
        event fundraising center.
      </Text>

      <Box>
        <Button
          as="a"
          colorScheme="blue"
          href={eventPage}
          mt={6}
          size="lg"
          w={isMobile ? '100%' : undefined}
          {...getDataTracking('visitEventPageButton')}
          style={{
            color: 'white',
            textDecoration: 'none',
            cursor: 'pointer',
          }}
        >
          Visit the event page
        </Button>
      </Box>
    </VStack>
  );
};

export const NotRegistered: FC = () => {
  const {
    data: {
      eventData: { eventInfo },
    },
  } = useAppContext();
  const eventPageUrl = eventInfo?.greeting_url || '';

  return (
    <Flex
      flexDirection={['column', 'column', 'row']}
      p={['1.25rem', '0px']}
      justifyContent="center"
    >
      <Patient />
      <RegisterForEvent eventPage={eventPageUrl} />
    </Flex>
  );
};
